module.exports = __webpack_public_path__ + "img/main-block-product-showcase-audivisual.2612b67b.svg";